'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FontIcon = require('material-ui/FontIcon');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Toggle = require('material-ui/Toggle');

var _Toggle2 = _interopRequireDefault(_Toggle);

var _locales = require('./locales');

var _locales2 = _interopRequireDefault(_locales);

var _themes = require('./themes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMenuItems = function getMenuItems(props) {
  var responsiveDrawer = props.responsiveDrawer,
      setResponsive = props.setResponsive,
      theme = props.theme,
      locale = props.locale,
      updateTheme = props.updateTheme,
      updateLocale = props.updateLocale,
      intl = props.intl,
      muiTheme = props.muiTheme,
      auth = props.auth,
      isGranted = props.isGranted;


  var isAuthorised = auth.isAuthorised;

  var themeItems = _themes.themes.map(function (t) {
    return {
      value: undefined,
      visible: true,
      primaryText: intl.formatMessage({ id: t.id }),
      onClick: function onClick() {
        updateTheme(t.id);
      },
      rightIcon: _react2.default.createElement(
        _FontIcon2.default,
        {
          className: 'material-icons',
          color: t.id === theme ? muiTheme.palette.primary1Color : undefined },
        'style'
      )
    };
  });

  var localeItems = _locales2.default.map(function (l) {
    return {
      value: undefined,
      visible: true,
      primaryText: intl.formatMessage({ id: l.locale }),
      onClick: function onClick() {
        updateLocale(l.locale);
      },
      rightIcon: _react2.default.createElement(
        _FontIcon2.default,
        {
          className: 'material-icons',
          color: l.locale === locale ? muiTheme.palette.primary1Color : undefined },
        'language'
      )
    };
  });

  return [{
    visible: isAuthorised,
    primaryText: intl.formatMessage({ id: 'chats' }),
    primaryTogglesNestedList: true,
    leftIcon: _react2.default.createElement(
      _FontIcon2.default,
      { className: 'material-icons' },
      'chats'
    ),
    nestedItems: [{
      value: '/chats',
      visible: isAuthorised,
      primaryText: intl.formatMessage({ id: 'private' }),
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'person'
      )
    }, {
      value: '/public_chats',
      visible: isAuthorised,
      primaryText: intl.formatMessage({ id: 'public' }),
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'group'
      )
    }, {
      value: '/predefined_chat_messages',
      visible: isAuthorised,
      primaryText: intl.formatMessage({ id: 'predefined_messages' }),
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'textsms'
      )
    }]
  }, {
    visible: isAuthorised, // In prod: isGranted('administration'),
    primaryTogglesNestedList: true,
    primaryText: intl.formatMessage({ id: 'administration' }),
    leftIcon: _react2.default.createElement(
      _FontIcon2.default,
      { className: 'material-icons' },
      'security'
    ),
    nestedItems: [{
      value: '/users',
      visible: isAuthorised, // In prod: isGranted('read_users'),
      primaryText: intl.formatMessage({ id: 'users' }),
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'group'
      )
    }, {
      value: '/roles',
      visible: isGranted('read_roles'),
      primaryText: intl.formatMessage({ id: 'roles' }),
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'account_box'
      )
    }]
  }, {
    divider: true,
    visible: isAuthorised
  }, {
    primaryText: intl.formatMessage({ id: 'settings' }),
    primaryTogglesNestedList: true,
    leftIcon: _react2.default.createElement(
      _FontIcon2.default,
      { className: 'material-icons' },
      'settings'
    ),
    nestedItems: [{
      primaryText: intl.formatMessage({ id: 'theme' }),
      secondaryText: intl.formatMessage({ id: theme }),
      primaryTogglesNestedList: true,
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'style'
      ),
      nestedItems: themeItems
    }, {
      primaryText: intl.formatMessage({ id: 'language' }),
      secondaryText: intl.formatMessage({ id: locale }),
      primaryTogglesNestedList: true,
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'language'
      ),
      nestedItems: localeItems
    }, {
      primaryText: intl.formatMessage({ id: 'responsive' }),
      leftIcon: _react2.default.createElement(
        _FontIcon2.default,
        { className: 'material-icons' },
        'chrome_reader_mode'
      ),
      rightToggle: _react2.default.createElement(_Toggle2.default, {
        toggled: responsiveDrawer.responsive,
        onToggle: function onToggle() {
          setResponsive(!responsiveDrawer.responsive);
        }
      })
    }]
  }];
};

exports.default = getMenuItems;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/menuItems.js
// module id = 708
// module chunks = 49